module.exports = __webpack_public_path__ + "static/article-image-c7beb07116069bbcc43be4254da1f63e.jpg";